"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.fetchContentGroups = void 0;

var _ActionTypes = _interopRequireDefault(require("ComposeUI/redux/ActionTypes"));

var _ContentGroupsManager = _interopRequireDefault(require("ComposeUI/data/ContentGroupsManager"));

var _utils = require("ComposeUI/lib/utils");

var contentGroupsManager = new _ContentGroupsManager.default();
var fetchContentGroupsPending = (0, _utils.createAction)(_ActionTypes.default.FETCH_CONTENT_GROUPS_PENDING);
var fetchContentGroupsSucceeded = (0, _utils.createAction)(_ActionTypes.default.FETCH_CONTENT_GROUPS_SUCCEEDED);
var fetchContentGroupsFailed = (0, _utils.createAction)(_ActionTypes.default.FETCH_CONTENT_GROUPS_FAILED);

var fetchContentGroups = function fetchContentGroups() {
  return function (dispatch) {
    dispatch(fetchContentGroupsPending());
    contentGroupsManager.fetch().then(function (resp) {
      return dispatch(fetchContentGroupsSucceeded(resp));
    }, function (resp) {
      return dispatch(fetchContentGroupsFailed(resp));
    });
  };
};

exports.fetchContentGroups = fetchContentGroups;